import { render, staticRenderFns } from "./Curbside.vue?vue&type=template&id=9f63bf3c&scoped=true"
import script from "./Curbside.vue?vue&type=script&lang=ts"
export * from "./Curbside.vue?vue&type=script&lang=ts"
import style0 from "./Curbside.vue?vue&type=style&index=0&id=9f63bf3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f63bf3c",
  null
  
)

export default component.exports